// @flow
import { handlePaginatedMapRequest } from '../phasedActionHelpers';

import type { LoadAlbumsByFilterAction } from '../../actions/album';

export type State = {
  +[key: string]: {|
    +entities: Array<string>,
    +loaded: boolean,
    +loadedCursors: { +[key: string]: boolean },
    +loading: boolean,
    +meta: {
      +count: number,
      +cursor: { +next: ?string, +prev: ?string },
    },
  |},
};

const initialState = {};

export default function albumsByFilter(
  state: State = initialState,
  action: LoadAlbumsByFilterAction
): State {
  if (action.type === 'FETCH_ALBUMS_BY_FILTER' && action.cacheId) {
    return handlePaginatedMapRequest(state, action, action.cacheId);
  }

  return state;
}
